import React, { useEffect } from "react";
import { stylesToString, hexToRGBA, ColorLuminance } from "../../helpers";
import { iconChevron } from "./iconChevron";
import "./index.scss";
import { EventEmitter } from "fbemitter";
const emitter = new EventEmitter();

export default (styles: { layoutVersion: number; [key: string]: unknown }) => {
  const { layoutVersion = 1 } = styles;

  const keyRewrite = (key: string) => {
    if (key.indexOf("TourPrimary") > 0) {
      return key.replace("TourPrimary", "Tour--primary");
    } else if (key.indexOf("TourSecondary") > 0) {
      return key.replace("TourSecondary", "Tour--secondary");
    } else if (key.indexOf("TourTertiary") > 0) {
      return key.replace("TourTertiary", "Tour--tertiary");
    }
    return key;
  };

  const lowContrastColors = ["#51f29a"];

  const chevronColorKeys = [
    "--primary",
    "--secondary",
    "--tertiary",
    "bannerNavTextColorTour"
  ];

  const darkerColorKeys = ["--primary", "--secondary", "--tertiary"];

  const keys = Object.keys(styles);
  let groomedStyles = keys.reduce(
    (obj: Record<string, unknown>, key: string) => {
      if (
        styles[key] &&
        styles[key] !== "no-image-set-for-this-viewport" &&
        styles[key] !== "layoutVersion"
      ) {
        obj[`--${keyRewrite(key)}`] = `${key.indexOf("Color") >= 0 ? "#" : ""}${
          key.indexOf("ImageBackground") >= 0
            ? `url(${styles[key]})`
            : styles[key]
        }`;

        if (chevronColorKeys.some(k => keyRewrite(key).indexOf(k) >= 0)) {
          // create different color chevrons from brand colours
          obj[`--${keyRewrite(key)}-chevron`] = `url(${iconChevron(
            `${styles[key]}`
          )})`;

          // create rgb css variables from rand colours
          obj[`--${keyRewrite(key)}-rgb`] = `${hexToRGBA(`${styles[key]}`)}`;
        }

        if (darkerColorKeys.some(k => keyRewrite(key).indexOf(k) >= 0)) {
          obj[`--${keyRewrite(key)}-darker`] = `${ColorLuminance(
            `${styles[key]}`,
            -0.25
          )}`;
        }
      }
      return obj;
    },
    {}
  );

  const brandColorKeys = [
    "--brandColorTour--primary",
    "--brandColorTour--secondary",
    "--brandColorTour--tertiary"
  ];
  const brightBrandColors = brandColorKeys
    .map(key => ({
      key,
      tooBright: lowContrastColors.some(color => groomedStyles[key] == color)
    }))
    .filter(color => color.tooBright)
    .map(color => color.key.replace("--brandColorTour--", "version__darker--"));

  const versionClasses =
    layoutVersion == 3
      ? brightBrandColors.length
        ? [
            ...brightBrandColors,
            `version__darker`,
            `version__2`,
            `version__${layoutVersion}`
          ]
        : [`version__2`, `version__${layoutVersion}`]
      : [`version__${layoutVersion}`];

  useEffect(() => {
    const head = document.querySelector("head");
    const main = document.querySelector("main");
    if (head !== null) {
      var styleNode = document.createElement("style");
      styleNode.setAttribute("id", "custom-theme");
      styleNode.setAttribute("layout-version", `${layoutVersion}`);
      styleNode.innerHTML = `:root{${stylesToString(groomedStyles)}}`;
      if (document) head.appendChild(styleNode);
    }
    if (main !== null && layoutVersion) {
      main.classList.add("theme", ...versionClasses);
    }
  }, []);

  return <></>;
};

export const themeListener = ({
  callback,
  name
}: {
  callback?: ({ layoutVersion }: { layoutVersion: number }) => void;
  name?: string;
}) => {
  emitter.addListener(
    `${name ? name : "themeLoaded"}`,
    ({ layoutVersion }: { layoutVersion: number }) => {
      if (callback) callback({ layoutVersion });
    }
  );
};

export const themeEmitter = ({
  layoutVersion,
  name
}: {
  layoutVersion: number;
  name?: string;
}) => {
  emitter.emit(`${name ? name : "themeLoaded"}`, { layoutVersion });
};
